import { render } from "./IconDashboard.vue?vue&type=template&id=faa092c8"
import script from "./IconDashboard.vue?vue&type=script&lang=js"
export * from "./IconDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__